import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { Observable } from "rxjs";
import { apiColletions } from "src/app/core/constants/api_collection";

@Injectable({
  providedIn: "root"
})
export class MapViewService {
  constructor(private apiService: ApiService) {}

  getDriverListForMapView(parameters: any): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      this.apiService.get({ url: apiColletions.driverMapView, parameters }).subscribe({
        next: (response) => {
          if (response.data) {
            observer.next(response.data.data);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }

  getDriverDetailedList(parameters: any): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      this.apiService.get({ url: apiColletions.driverDetails, parameters }).subscribe({
        next: (response) => {
          if (response.data) {
            observer.next(response.data.data);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        },
        error: () => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }
}
